import React from 'react'
import { Text } from '../../../../styles/reactnative'
import SettingChange from './SettingChange'
import EntryTime from '../../../components/PositionColumns/EntryTime'

export const columns = (mutate, usermodal) => {
	return [
		{
			title: '프로세스명',
			dataIndex: 'process',
			key: 'process',
			align: 'center',
			render: (text, record) => (
				<Text style={{ fontSize: 12 }}>{text}</Text>
			),
		},
		{
			title: '관리',
			dataIndex: 'action',
			key: 'action',
			align: 'center',
			render: (text, record) => (
				<SettingChange data={record} mutate={mutate} />
			),
		},
	]
}
